import { useEffect, useDebugValue, useCallback } from 'react';
import { useMeasuredCookieState } from './useMeasuredCookieState';
function isServerRendering() {
    return typeof document === 'undefined' || typeof window === 'undefined';
}
export function useMeasuredCookie(cookieType, containerRef, { defaultSize: defaultSizeProp , cookieDim ='both' , listenOnWindow , sentinelRef , version =0  }) {
    const { containerSize , defaultSizeForPlatform , updateContainerSize  } = useMeasuredCookieState(cookieType, cookieDim, defaultSizeProp, !!sentinelRef || isServerRendering());
    useDebugValue(containerSize, (size)=>{
        return `Width: ${size === null || size === void 0 ? void 0 : size.width}, height: ${size === null || size === void 0 ? void 0 : size.height}`;
    });
    const measureContainerSize = useCallback(()=>{
        function getContainerSize() {
            var _sentinelRef_current;
            // We are in browser from here
            const containerElement = containerRef.current;
            const rect = containerElement === null || containerElement === void 0 ? void 0 : containerElement.getBoundingClientRect();
            if (!rect || !rect.width && !rect.height) {
                return defaultSizeForPlatform;
            }
            const sentinelWidth = sentinelRef === null || sentinelRef === void 0 ? void 0 : (_sentinelRef_current = sentinelRef.current) === null || _sentinelRef_current === void 0 ? void 0 : _sentinelRef_current.getBoundingClientRect().width;
            return {
                // Make sure container is never bigger than parent
                // this allows us to shrink the container :)
                width: sentinelWidth && sentinelWidth < rect.width ? sentinelWidth : rect.width,
                height: rect.height
            };
        }
        const newSize = getContainerSize();
        updateContainerSize(newSize);
    }, [
        containerRef,
        defaultSizeForPlatform,
        sentinelRef,
        updateContainerSize
    ]);
    useEffect(()=>{
        measureContainerSize();
        if (listenOnWindow) {
            window.addEventListener('resize', measureContainerSize);
            return ()=>window.removeEventListener('resize', measureContainerSize);
        }
    }, [
        listenOnWindow,
        measureContainerSize,
        version
    ]);
    return containerSize;
}
